import axios from 'axios';
import PlanEditar from '../types/PlanEditar';

async function InsertarPlan(PlanNuevo: PlanEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_plan"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "plan": [
                {
                    "title": PlanNuevo.title,
                    "descripcion": PlanNuevo.description,
                    "maxconyuge": PlanNuevo.maxconyuge,
                    "maxmenores": PlanNuevo.maxmenores,
                    "maxmayores": PlanNuevo.maxmayores,
                    "headercolor": PlanNuevo.headercolor,
                    "headercolorhover": PlanNuevo.headercolorhover,
                    "price": PlanNuevo.price,
                    "pricedebito": PlanNuevo.pricedebito,
                    "priceanual": PlanNuevo.priceanual,
                    "codigoplan": PlanNuevo.codigoplan,
                    "habilitado": PlanNuevo.habilitado,
                    "maxedadtitular": PlanNuevo.maxedadtitular,
                    "maxedadconyuge": PlanNuevo.maxedadconyuge,
                    "maxedadmenor": PlanNuevo.maxedadmenor,
                    "maxedadmayor": PlanNuevo.maxedadmayor,
                    "mostrar": PlanNuevo.mostrar,
                    "sol_celu": PlanNuevo.sol_celu,
                    "val_celu": PlanNuevo.val_celu,
                    "sol_email": PlanNuevo.sol_email,
                    "val_email": PlanNuevo.val_email,
                    "pago_online": PlanNuevo.pago_online
                }
            ]
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarPlan;